module.exports = __webpack_public_path__ + "static/media/media-upload.d86c0b5d.svg";